import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import {
    Table,
    Button, Row, Col, Container,
    Modal, ModalHeader, ModalBody, ModalFooter
} from "reactstrap";
import Chart from "react-google-charts";

import "react-datepicker/dist/react-datepicker.css";
import Moment from 'react-moment';
// CSS Modules, react-datepicker-cssmodules.css
// import 'react-datepicker/dist/react-datepicker-cssmodules.css';
import axios from "axios";

const Reports = () => {
    const [startDate, setStartDate] = useState(new Date(Date.now() - 7 * 24 * 60 * 60 * 1000));
    const [endDate, setEndDate] = useState(new Date());
    const [salesData, setSalesData] = useState([]);
    const [itemsData, setItemsData] = useState([]);
    const [outlets, setOutlets] = useState([]);
    const [staffs, setStaffs] = useState([]);
    const [outlet, setOutlet] = useState('all');
    const [staff, setStaff] = useState('all');
    function handleClick() {
        var start_date = startDate.toJSON()
        var end_date = endDate.toJSON()
        const access = sessionStorage.getItem('access');
        axios({
            method: 'get',
            url: `https://api.chicking-malappuram.in/api/reports/?start_date=${start_date}&end_date=${end_date}&outlet=${outlet}&staff=${staff}`,
            headers: { 'Authorization': `Bearer ${access}` }
        }).then((res) => {
            console.log("res", res)
            setSalesData(res.data.salesData)
            setItemsData(res.data.itemData)
        });
    }
    async function fetchStaffs() {
        const access = sessionStorage.getItem('access');
        const requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer' + ' ' + access,
            },
        }
        const res = await fetch("https://api.chicking-malappuram.in/api/staffs/", requestOptions);
        const data = await res.json();
        if (data.length > 0) {
            setStaffs(data);
        }
    }
    async function fetchOutlets() {
        const access = sessionStorage.getItem('access');
        const requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer' + ' ' + access,
            },
        }
        //console.log(requestOptions);
        const res = await fetch("https://api.chicking-malappuram.in/api/outlets/", requestOptions);
        res
            .json()
            .then(res => setOutlets(res))
    }
    useEffect(() => {
        handleClick();
        fetchOutlets();
        fetchStaffs();
    }, []);
    return (
        <div className="content">
            <Container>
                <div className="card chicking-card">
                    <Row>
                        <Col md="2">
                            <label>From:</label>
                            <DatePicker className="date-picker" selected={startDate} onChange={date => setStartDate(date)} />
                        </Col>
                        <Col md="2">
                            <label>To:</label>
                            <DatePicker className="date-picker" selected={endDate} onChange={date => setEndDate(date)} />
                        </Col>
                        <Col md="2">
                            <label>Outlet</label>
                            <select value={outlet} className="form-control" onChange={e => setOutlet(e.currentTarget.value)}>
                                <option value="all">All</option>
                                {
                                    outlets.map(outlet => (
                                        <option value={outlet.id} selected>{outlet.location}</option>
                                    ))
                                }
                            </select>
                        </Col>
                        <Col md="2">
                            <label>Staff</label>
                            <select className="form-control" value={staff} onChange={e => setStaff(e.currentTarget.value)}>
                                <option value="all" selected>All</option>
                                {
                                    staffs.map(staff => (
                                        staff.staff_type == 'customer_call_staff' &&
                                        <option value={staff.id} selected>{staff.name}</option>
                                    ))
                                }
                            </select>
                        </Col>
                        <Col md="2">
                            
                            <Button style={{marginTop:22}} onClick={handleClick}>Refresh</Button>
                        </Col>
                        <Col md="2">
                           
                            <Button style={{marginTop:22}} onClick={handleClick}> <a target="blank" href={`https://api.chicking-malappuram.in/customer-sheet?start_date=${startDate.toJSON()}&end_date=${endDate.toJSON()}&outlet=${outlet}&staff=${staff}`}>Excel</a></Button>
                        </Col>

                    </Row>
                    <Chart
                        width={'100%'}
                        height={'300px'}
                        chartType="AreaChart"
                        loader={<div>Loading Chart</div>}
                        data={salesData}
                        options={{
                            title: 'Sales graph',
                        }}
                        rootProps={{ 'data-testid': '1' }}
                    />
                    <Chart
                        width={'100%'}
                        height={'400px'}
                        chartType="PieChart"
                        loader={<div>Loading Chart</div>}
                        data={itemsData}
                        options={{
                            title: 'top selling items',
                        }}
                        rootProps={{ 'data-testid': '1' }}
                    />

                </div>
            </Container>
        </div>
    );
};
export default Reports